import {
  FETCH_PVS_SUBCATEGORY_DETAILS_REQUEST,
  FETCH_PVS_SUBCATEGORY_DETAILS_SUCCESS,
  FETCH_PVS_SUBCATEGORY_DETAILS_FAILURE,
  RESET_PVS_STATE,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const fetchPvsSubcategoryDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PVS_SUBCATEGORY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case FETCH_PVS_SUBCATEGORY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "Subcategory details fetched successfully",
      };

    case FETCH_PVS_SUBCATEGORY_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to fetch subcategory details",
      };

    case RESET_PVS_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default fetchPvsSubcategoryDetailReducer;
